import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';
import { AuthContext } from './context/AuthContext';

const App = ({ darkMode, setDarkMode }) => {
    const { authData } = useContext(AuthContext);
    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/home" element={authData.jwt ? <Home darkMode={darkMode} setDarkMode={setDarkMode} /> : <Navigate to="/login" />} />
                <Route path="*" element={<Navigate to={authData.jwt ? "/home" : "/login"} />} />
            </Routes>
        </Router>
    );
};

export default App;
